// extracted by mini-css-extract-plugin
module.exports = {"title":"gallery-module__title___If_jI","description":"gallery-module__description___256J5"};